import { ElibraryDataSourceFactory } from "@sabyr-dev/mist_elibrary";
import {
	ListDataSource, MetadataDataSource, PqItemDataSource, ScoreDataSource,
	Serializer, SettingsDataSource, StateDataSource, StateInitializer
} from "@sabyr-dev/mist_core/model/datasource";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import { AcademyItemDataSource } from "./item";
import { AcademyListDataSource } from "./list";
import { AcademyMetadataDataSource } from "./metadata";
import { AcademyScoreDataSource } from "./score";
import { AcademySettingsDataSource } from "./settings";
import { GlobalState } from "@sabyr-dev/mist_core/model/datasource/state";
import {
	AcademyAttemptState, AcademyAttemptStateDataSource,
	AcademyGlobalStateDataSource
} from "./state";
import { AcademyAttemptStateInitializer } from "./stateinitializer";

export { AcademyItemDataSource } from "./item";
export { AcademyListDataSource } from "./list";
export { AcademyMetadataDataSource } from "./metadata";
export { AcademyScoreDataSource, AcademyAttemptTableRecord } from "./score";
export { AcademySettingsDataSource } from "./settings";
export {
	AcademyAttemptState, AcademyAttemptStateDataSource,
	AcademyGlobalStateDataSource
} from "./state";
export { AcademyAttemptStateInitializer } from "./stateinitializer";

export class AcademyDataSourceFactory extends ElibraryDataSourceFactory {
	listDataSource(item: Serializer<Question>): ListDataSource<Question> { return new AcademyListDataSource(item); }
	metadataDataSource(): MetadataDataSource<Product, Attempt> { return new AcademyMetadataDataSource(); }
	itemDataSource(): PqItemDataSource<Product, Attempt, Question> { return new AcademyItemDataSource(); }
	scoreDataSource(quiz: Serializer<Quiz>): ScoreDataSource<Attempt, Quiz> { return new AcademyScoreDataSource(quiz); }
	settingsDataSource(): SettingsDataSource<Product> { return new AcademySettingsDataSource(); }
	globalStateDataSource(initializer: StateInitializer<GlobalState>): StateDataSource<GlobalState> {
		return new AcademyGlobalStateDataSource(initializer);
	}
	attemptStateDataSource(initializer: StateInitializer<AcademyAttemptState>): StateDataSource<AcademyAttemptState> {
		return new AcademyAttemptStateDataSource(initializer);
	}
	attemptStateInitializer(): StateInitializer<AcademyAttemptState> | undefined {
		return new AcademyAttemptStateInitializer();
	}
}
